import { ActionId, StepId } from 'config/steps';
import { SelectCategoryStep } from 'steps/select-category/SelectCategoryStep';
import { createFlow } from '@wix/gg-components/orchestrator';
import { StepParams, StepRenderPart } from 'types/steps';
import { SelectCategoryStepGallery } from 'steps/select-category/components/SelectCategoryStepGallery';
import { SelectProductsStep } from 'steps/select-products/SelectProductsStep';
import { SelectProductsStepPreview } from 'steps/select-products/components/SelectProductsStepPreview';
import { actions } from 'api/actions';
import { redirects } from 'api/redirects';
import { SelectImageStep } from 'steps/select-image/SelectImageStep';
import { StoreSetupStep } from 'steps/store-setup/StoreSetupStep';
import { SelectNameStep } from 'steps/select-name/SelectNameStep';
import { SelectImageStepPreview } from 'steps/select-image/components/SelectImageStepPreview';
import { endpoints } from 'api/endpoints';
import { StoreReadyStep } from 'steps/store-ready/StoreReadyStep';
import { LandingPageStep } from 'steps/landing-page/LandingPageStep';
import { SelectNameStepPreview } from 'steps/select-name/components/SelectNameStepPreview';
import { StoreSetupStepPreview } from 'steps/store-setup/components/StoreSetupStepPreview';
import { useIsMobile } from './useIsMobile';
import { StoreReadyStepMobile } from 'steps/store-ready/components/StoreReadyStepMobile';
import { withRetry } from 'utils/with-retry';

export const useFlowBuilder = () => {
  const isMobile = useIsMobile();

  const flow = createFlow<StepParams, StepRenderPart>();
  flow.step(StepId.LandingPage, LandingPageStep, { hideProgress: true });

  flow.step(
    StepId.SelectCategory,
    { main: SelectCategoryStep, side: SelectCategoryStepGallery },
    { sideRatio: 'fill', disableBack: true },
  );

  flow.step(StepId.SelectProducts, { main: SelectProductsStep, side: SelectProductsStepPreview });

  flow.action(ActionId.RedirectToLogin, redirects.redirectToLogin);
  flow.action(ActionId.CreateMetaSite, actions.createMetaSite);
  flow.action(ActionId.InstallSiteApps, actions.installSiteApps);
  flow.action(ActionId.RedirectToConnectPrintful, redirects.redirectToConnectPrintful);

  flow.step(StepId.SelectImage, { main: SelectImageStep, side: SelectImageStepPreview }, { sideRatio: 'fill' });
  flow.task(ActionId.AddStoreProducts, async () => {
    await Promise.all([actions.uploadSiteMedia(), withRetry(() => endpoints.resetStore({}), 4, 2 * 1000)]);
    actions.addStoreProducts();
  });

  flow.step(StepId.SelectName, { main: SelectNameStep, side: SelectNameStepPreview }, { sideRatio: 'fill' });

  flow.step(
    StepId.StoreSetup,
    { main: StoreSetupStep, side: StoreSetupStepPreview },
    { hideProgress: true, sideRatio: 'fill' },
  );

  if (isMobile) {
    flow.step(StepId.StoreReady, { main: StoreReadyStepMobile }, { hideProgress: true });
  } else {
    flow.step(StepId.StoreReady, { side: StoreReadyStep }, { hideProgress: true, sideRatio: 'full' });
  }

  flow.action(ActionId.RedirectToUpgradePlan, redirects.redirectToUpgradePlan);
  return flow.build();
};
